import React from 'react';
import * as date from "../util/date";

export default function Event(props) {

    const event = props.event;

    function isEventMultiDay(event) {
        return date.formatDateTime(event.date, 'date') !== date.formatDateTime(event.date_end, 'date');
    }



    return (
        <div>
            <tr className="fc-list-heading" data-date={date.formatDateTime(event.date, 'date')} style={{width : "100%", display : "flex"}}>
                <td className="fc-widget-header" colSpan="3">
                    <>{/*eslint-disable-next-line*/}</>
                    <a className="fc-list-heading-main">
                    {date.formatDateTime(event.date, 'date')}
                    {isEventMultiDay(event) ? ' - ' + date.formatDateTime(event.date_end, 'date') : null}
                    </a>
                </td>
            </tr>
            <tr className="fc-list-item">
                <td className="fc-list-item-time fc-widget-content">
                    {date.formatDateTime(event.date, 'time')} - {date.formatDateTime(event.date_end, 'time')}
                </td>
                <td className="fc-list-item-marker fc-widget-content">
                    <span className="fc-event-dot" style={{backgroundColor: "#005683"}}></span>
                </td>
                <td className="fc-list-item-title fc-widget-content">
                    <a href={event.url}>
                        <h2>
                            {event.title}
                        </h2>
                        <div dangerouslySetInnerHTML={{__html: event.body}}></div>
                        <div style={{display: "none"}}>
                            {event.territories}
                        </div>
                        <div style={{display: "none"}}>
                            {event.themes}
                        </div>
                    </a>
                </td>
            </tr>
            {/*// <div>*/}
            {/*//     <h1>{event.title}</h1>*/}
            {/*//     <p>{formatDateTime(event.date, 'date')}</p>*/}
            {/*//     <p>{formatDateTime(event.date, 'time')}</p>*/}
            {/*//     <p>{event.territories}</p>*/}
            {/*//     <p>{event.themes}</p>*/}
            {/*//     <div dangerouslySetInnerHTML={{__html: event.body}}></div>*/}
            {/*// </div>*/}
        </div>
    )
}